import { useTranslation } from 'react-i18next';
import TextareaField from 'shared/components/form/TextareaField';
import TextField from 'shared/components/form/TextField';
import { UpdateFormT } from 'shared/form-values/actors';
import { Flex } from "@chakra-ui/react";
import Field from "../../../components/form/Field";



const Form = () => {
  const { t } = useTranslation();



  return (
    <Flex gap="20px" direction="column">
      <TextField<UpdateFormT>
        name="name"
        label={t('services.table.name')}
        placeholder={t('services.table.name')}
        required

      />
      <TextField<UpdateFormT>
        name="nick"
        label={t('services.table.nick')}
        placeholder={t('services.table.nick')}
        required

      />
      <TextField<UpdateFormT>
        name="bio"
        label={t('services.table.bio')}
        placeholder={t('services.table.bio')}
        required

      />
      <Field
        type="file"
        name="files"
        label="File"
        acceptedFileTypes="image/*"
      />
      <TextareaField<UpdateFormT>
        name="prompt"
        label="Prompt"
        placeholder="Enter prompt"
        required
      />
    </Flex>
  );
};

export default Form;
